module.exports = __webpack_public_path__ + "static/szenario2_1-b325a98f9f4ace248911088fa03f794e.png";